import {Pipe, PipeTransform} from "@angular/core";
import {DateTime} from "date-time-js";

@Pipe({name: "dt"})
export class DtPipe implements PipeTransform {
  transform(value: any, format: string): string {
    return new DateTime(new Date(value)).format(format);
  }
}
